import React, {useEffect, useState} from 'react';
import {useSelector} from "react-redux";
import {
    bbDangerousStringToDate,
    BBDisableChildren, bbDoesUserHaveAccessToBreachRiskLevelForEntity,
    bbFindEntityWithinPortfolioOrSelf, bbFormattedDateString, bbIsEntityAwaitingFirstScoreCycle,
    bbTranslateBreachRiskScoreToCategory, bbTranslateBreachRiskScoreToColor,
    isCurrentUserMemberOf
} from "../../../../../util/bbHelpers";
import Banner from "../../../../../assets/images/BreachRisk_Social_Banner.svg";
import {Badge, Col, Row} from "reactstrap";
import BreachRiskScoreCyclePendingModal
    from "../../../../../components/customBreachBits/modals/BreachRiskScoreCyclePendingModal";
import BRSocialIdentitiesTable
    from "../../../../../components/customBreachBits/BRSocialReports/BRSocialIdentitiesTable";
import TileBRSocialNumIdentities
    from "../../../../../components/customBreachBits/BRSocialReports/TileBRSocialNumIdentities";
import TileBRSocialAllTimeNumTests from "../../../../../components/customBreachBits/BRSocialReports/TileBRSocialAllTimeNumTests";
import BBExternalLink from "../../../../../components/customBreachBits/accents/BBExternalLink";
import EarlyAccessWrapper from "../../../../../components/customBreachBits/settings/EarlyAccessWrapper";
import BRSocialEngineeringAuthorizationWidget
    from "../../../../../components/customBreachBits/BRSocialReports/BRSocialEngineeringAuthorizationWidget";
import PremiumCustomersOnlyWrapper
    from "../../../../../components/customBreachBits/BRSocialReports/PremiumCustomersOnlyWrapper";
import TileBRSocialAllTimeOpen
    from "../../../../../components/customBreachBits/BRSocialReports/TileBRSocialAllTimeOpen";
import TileBRSocialAllTimeExecuted
    from "../../../../../components/customBreachBits/BRSocialReports/TileBRSocialAllTimeExecuted";
import TileBRSocialALlTimeBreached
    from "../../../../../components/customBreachBits/BRSocialReports/TileBRSocialAllTimeBreached";
import BRSocialCycleHistoryChart
    from "../../../../../components/customBreachBits/BRSocialReports/BRSocialCycleHistoryChart";
import testSocialCycleHistoryObject
    from "../../../../../components/customBreachBits/BRSocialReports/testSocialCycleHistoryObject";
import Select from "react-select";
import SocialCycleResponseSection
    from "../../../../../components/customBreachBits/BRSocialReports/SocialCycleResponseSection";
import VerifiedOwnershipRequiredDialog
    from "../../../../../components/customBreachBits/OnboardingProgress/VerifiedOwnershipRequiredDialog";
import DisableChildrenIfDoesntHaveAccessToSubscriptionLevel
    from "../../../../../components/customBreachBits/modals/DisableChildrenIfDoesntHaveAccessToSubscriptionLevel";
import IdentitiesSocialHistoryChart
    from "../../../../../components/customBreachBits/charts/IdentitiesSocialHistoryChart";
import CycleProgressStepper from "../../../../../components/customBreachBits/info/CycleProgressStepper";
import SocialEngineeringIsOffModal from "../../../../../components/customBreachBits/modals/SocialEngineeringIsOffModal";
import BRCompanyScoreVerifiedBadge
    from "../../../../../components/customBreachBits/BBRiskMeter/BRCompanyScoreVerifiedBadge";
import {BRCustomizedTooltip as Tooltip} from "../../../../../components/customBreachBits/accents/BRCustomizedTooltip";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";


const SocialEngineeringPage=({
                                portfolioView=false,
                             })=>{

    const testData = testSocialCycleHistoryObject;


    const {customers, customerInView} = useSelector(({customer}) => customer);

    const {portfolios, entityInView} = useSelector(({breachrisk}) => breachrisk);
    const {authUser} = useSelector(({auth}) => auth);

    const hasEarlyAccess = EarlyAccessWrapper();
    const isStaffAdmin = isCurrentUserMemberOf(authUser, "admin") || isCurrentUserMemberOf(authUser, "staff");
    const isTrustedAgentForThisEntity = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel3", entityInView);
    const isAdministratorForThisEntity = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel4", entityInView);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const customer = customers ? customers[customerIdToUse] : null;

    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);
    const hasPremiumAccess = myEntity ? myEntity.active_subscription && myEntity.premium_subscription : null;

    const userHasAccess = myEntity && (isStaffAdmin || myEntity.premium_subscription)
    const entityHasSocialOn = myEntity && myEntity.settings && myEntity.settings.social_testing_authorized;

    const lastCycle = myEntity ? myEntity.last_cycle : null

    const isCycleOngoing = myEntity
        && myEntity.settings
        && myEntity.settings.ongoing_cycle_complete_datetime;

    const social = myEntity
        && myEntity.cycles
        && myEntity.cycles[lastCycle.cycle]
        && myEntity.cycles[lastCycle.cycle].social

    const cycleTotals= social && social.cycleTotals;
    const allTimeTotals = social && social.allTimeTotals;

    const hasCycleSocialData = cycleTotals && ((cycleTotals.number_identities + cycleTotals.number_social_tests + cycleTotals.number_social_tests_action_taken +
        cycleTotals.number_social_tests_opened + cycleTotals.number_social_tests_successful) > 0);

    const historyDataWithSocialTests = myEntity
        && myEntity.history
        && Array.isArray(myEntity.history)
        && myEntity.history
            .filter((cycle)=> cycle && cycle.social && cycle.social.tests && cycle.social.tests > 0)
            .sort((a,b) => (bbDangerousStringToDate(b.cycle_date) > bbDangerousStringToDate(a.cycle_date) ? 1 : -1));

    // const historyDataWithSocialTests = testData
    //     .sort((a,b) => (bbDangerousStringToDate(b.cycle_date) > bbDangerousStringToDate(a.cycle_date) ? 1 : -1));

    const allHistoryData = myEntity
        && myEntity.history
        && Array.isArray(myEntity.history)
        && myEntity.history
            .sort((a,b) => (bbDangerousStringToDate(b.cycle_date) > bbDangerousStringToDate(a.cycle_date) ? 1 : -1));

    // const allHistoryData = testData
    //     .sort((a,b) => (bbDangerousStringToDate(b.cycle_date) > bbDangerousStringToDate(a.cycle_date) ? 1 : -1));

    const hasMoreThanOneSocialCycle = historyDataWithSocialTests && historyDataWithSocialTests.length > 1;

    // console.log("checking hasMoreThanOneSocialCycle", hasMoreThanOneSocialCycle, historyDataWithSocialTests, allHistoryData);

    const [cycleToView, setCycleToView] = useState(myEntity && myEntity.settings && myEntity.settings.last_cycle_id);

    const chartCallBackToChangeCycleToView = (cycleId) => {
        console.log("Got chartCallBackToChangeCycleToView", cycleId);
        // alert(cycleId);
        setCycleToView(cycleId);
    }

    // useEffect(()=>{
    //     if(myEntity && !cycleToView) {
    //         setCycleToView(myEntity.settings && myEntity.settings["last_cycle_id"]);
    //     }
    // }, [myEntity, cycleToView]);

    const breachRiskScore = myEntity && myEntity.last_cycle ? myEntity.last_cycle.score : null;
    const breachRiskCategory = bbTranslateBreachRiskScoreToCategory(breachRiskScore);

    const selectOptions = allHistoryData && allHistoryData
        .map((cycle)=>{
        return {
            label: bbFormattedDateString(cycle.cycle_date, "shortFullMonth"),
            value: cycle.cycle,
        }}
    );

    // console.log("cycleToView", cycleToView)
    return(

    <div className="app-wrapper">

        <div className="animated fadeIn animation-duration-7">
            <div className="row">
                <div className={"col-8 align-self-center"}>
                    <div className={"mx-0 px-0"}>
                        <div style={{backgroundImage: `url(${Banner})`,  width: "400px", backgroundRepeat: "no-repeat", backgroundPosition: "left center", height: "60px"}}/>
                        <h3>{!bbIsEntityAwaitingFirstScoreCycle(myEntity) && <> {myEntity && myEntity.settings ? bbFormattedDateString(myEntity.settings.last_cycle_datetime, "shortFullMonth") : ""} | </>}{myEntity ? myEntity.name : ""}
                            <span>
                              <BRCompanyScoreVerifiedBadge
                                  entityId={entityInView}
                                  hideDescription
                                  fontSizeOverride={"1.0em"}
                                  inline
                              />
                          </span>
                        </h3>
                        {(portfolioView && (isStaffAdmin || isTrustedAgentForThisEntity)) || !portfolioView
                            ?<p><small>Currently, <strong>BreachRisk™ Social does not affect your BreachRisk™ Score </strong> - but it will soon. <BBExternalLink tipText={"Knowledge Base: Read more about how social engineering will integrate into BreachRisk™"} href={"https://support.breachbits.com/knowledge/about-social-engineering"}>Learn more.</BBExternalLink></small></p>
                            : null}
                    </div>
                    {(portfolioView && (isStaffAdmin || isTrustedAgentForThisEntity)) || !portfolioView
                        ?<p>Unlike many other phishing services that focus on quantity, we carefully craft attacks designed to not only test whether your team is <em>opening</em> phishing emails, but also if your security controls will prevent us from actually executing the attacks that follow.</p>
                        : null}

                </div>
                <div className={"col-4 align-self-center"}>
                    <h3>Test the weakest link. </h3>
                    <p>BreachRisk™ Social brings our powerful precision phishing engine from our CIRT™ service into BreachRisk™.</p>
                    {isCycleOngoing
                        ?   <h5>Next Report Available: {myEntity && myEntity.settings ? bbFormattedDateString(myEntity.settings.ongoing_cycle_complete_datetime, "shortFullMonth") : ""}</h5>

                        : <h5>Next Assessment Start: {myEntity && myEntity.settings ? bbFormattedDateString(myEntity.settings.next_cycle_datetime, "shortFullMonth") : ""}</h5>
                    }
                    <CycleProgressStepper/>
                </div>
            </div>
            <hr/>
            {(portfolioView && (isStaffAdmin || isTrustedAgentForThisEntity)) || !portfolioView
                ? <SocialEngineeringIsOffModal>
                <VerifiedOwnershipRequiredDialog>
                    {/*jfd Removed early access*/}
                    {/*{hasEarlyAccess || isStaffAdmin*/}

                    {/*    ?*/}
                        <BreachRiskScoreCyclePendingModal entity={myEntity}>
                            {/*<BRSocialEngineeringAccessModal entity={myEntity}>*/}

                            <div>
                                <Row className={"align-self-center"}>
                                    <Col lg={6} className={"text-center align-self-center"}>
                                        <p>Social Engineering and Testing requires a premium account and authorization, but all paid BreachRisk&trade; subscription levels have access to our collection of identities associated with your company.</p>
                                    </Col>
                                    <Col id={"tourEnableTesting"}>
                                        <BRSocialEngineeringAuthorizationWidget brSubscriptionRequired={isTrustedAgentForThisEntity ? "Premium" : null}/>
                                    </Col>
                                </Row>
                                <hr/>
                                <h1  id={"tourSocialStepOne"}>Identities Analysis</h1>
                                <p>Attackers strive to understand your social landscape before conducting attacks. They use multiple sources and direct observations to understand this landscape.</p>

                                <Row >
                                    <Col lg={1}/>

                                    <Col lg={5}>
                                        <TileBRSocialNumIdentities/>
                                    </Col>
                                    <Col lg={5}>
                                        {/*<PremiumCustomersOnlyWrapper>*/}
                                        <DisableChildrenIfDoesntHaveAccessToSubscriptionLevel premium>
                                            <TileBRSocialAllTimeNumTests/>
                                        </DisableChildrenIfDoesntHaveAccessToSubscriptionLevel>
                                        {/*</PremiumCustomersOnlyWrapper>*/}
                                    </Col>
                                    <Col lg={1}/>
                                </Row>


                                {/*<EarlyAccessWrapper>*/}
                                    <Row  id={"tourIdentitiesChart"}>
                                        <Col>
                                            {/*<DisableChildrenIfDoesntHaveAccessToSubscriptionLevel premium>*/}
                                                <IdentitiesSocialHistoryChart entity={entityInView}/>
                                            {/*</DisableChildrenIfDoesntHaveAccessToSubscriptionLevel>*/}
                                        </Col>
                                    </Row>
                                {/*</EarlyAccessWrapper>*/}

                                <Row>
                                    <Col>
                                        <BRSocialIdentitiesTable portfolioView={portfolioView}/>
                                    </Col>
                                </Row>
                                <hr/>

                                <h1>Phishing Attack Testing</h1>
                                <p>In this section, you can view the results of our highly sophisticated phishing attacks that emulate real attackers. Unlike many other phishing emulators, our process tests the <em>entire</em> security stack: opens and clicks, but also <strong>payload execution</strong> with realistic attempts focused on achieving a high attack success rate, not high volume. Phishing remains one of the top ways attackers can gain an initial foothold to conduct further attacks.</p>



                                <Row className={"text-center align-self-center"} id={"tourSocialResponseOverview"}>
                                    <Col sm={4}  className={"align-self-center"}>
                                        <PremiumCustomersOnlyWrapper portfolioView={portfolioView}>
                                            <TileBRSocialAllTimeOpen/>
                                        </PremiumCustomersOnlyWrapper>
                                    </Col>
                                    <Col sm={4}  className={"align-self-center"}>
                                        <PremiumCustomersOnlyWrapper portfolioView={portfolioView}>
                                            <TileBRSocialAllTimeExecuted/>
                                        </PremiumCustomersOnlyWrapper>
                                    </Col>
                                    <Col sm={4}  className={"align-self-center"}>
                                        <PremiumCustomersOnlyWrapper portfolioView={portfolioView}>
                                            <TileBRSocialALlTimeBreached/>
                                        </PremiumCustomersOnlyWrapper>
                                    </Col>
                                </Row>

                                <PremiumCustomersOnlyWrapper portfolioView={portfolioView}>
                                <div>
                                    <Row className={"m-2 p-1"}>
                                        <Col>
                                                <BRSocialCycleHistoryChart
                                                    cycleId={cycleToView}
                                                    cycleChangeFunction={chartCallBackToChangeCycleToView}
                                                />
                                        </Col>

                                    </Row>

                                    <Row className={"align-self-center"}>
                                        <Col sm={2}>

                                        </Col>
                                        <Col sm={2}>

                                        </Col>
                                        <Col sm={4} className={"text-right align-self-center"}>
                                            <h4 className={"align-self-center"}>Select Date: </h4>
                                        </Col>
                                        <Col sm={4} className={"p-0 m-0  align-self-center"}>
                                            {allHistoryData && allHistoryData.length > 1 ?
                                                <Select
                                                    options={selectOptions}
                                                    onChange={(value)=> setCycleToView(value.value)}
                                                    value={cycleToView ? selectOptions.find(x => x.value === cycleToView) : null}
                                                    defaultValue={cycleToView ? selectOptions.find(x => x.value === cycleToView) : selectOptions[0]}
                                                    className={"align-self-center m-0 p-0"}
                                                />

                                                : <Select
                                                    options={[{label: <em>No Past Reports to Show</em>, value: null,}, ]}
                                                    isDisabled={true}
                                                    className={"align-self-center m-0 p-0"}
                                                />}

                                        </Col>
                                    </Row>
                                    <br/>
                                </div>
                                </PremiumCustomersOnlyWrapper>


                                <SocialCycleResponseSection cycleId={cycleToView ? cycleToView : null} portfolioView={portfolioView}/>


                            </div>
                            {/*</BRSocialEngineeringAccessModal>*/}
                        </BreachRiskScoreCyclePendingModal>

                    {/*//     : <>*/}
                    {/*//         <Row>*/}
                    {/*//             <Col>*/}
                    {/*//                 <TileComingSoon subtitle={"Coming Soon"}/>*/}
                    {/*//             </Col>*/}
                    {/*//             <Col>*/}
                    {/*//                 <TileComingSoon subtitle={"Coming Soon"}/>*/}
                    {/*//             </Col>*/}
                    {/*//             <Col>*/}
                    {/*//                 <TileComingSoon subtitle={"Coming Soon"}/>*/}
                    {/*//             </Col>*/}
                    {/*//         </Row>*/}
                    {/*//         <Row>*/}
                    {/*//             <Col>*/}
                    {/*//                 <TileComingSoon subtitle={"Coming Soon"}/>*/}
                    {/*//             </Col>*/}
                    {/*//         </Row>*/}
                    {/*//     </>*/}
                    {/*// }*/}

                </VerifiedOwnershipRequiredDialog>
            </SocialEngineeringIsOffModal>
                : <>
                    <br/>
                    <br/>
                    <br/>
                    <Tooltip title={"If you need these details, this company will need to approve a request."} link={`https://support.breachbits.com/knowledge/requesting-access`}>
                        <h2 className={"text-center"}>You don't have Trusted Agent privileges for this Entity <InfoSharpIcon/></h2>
                    </Tooltip>

                    <br/>
                    <br/>
                </>}


        </div>
    </div>
    )
}

export default SocialEngineeringPage;